import { render, staticRenderFns } from "./collections.vue?vue&type=template&id=3d10cedc&"
import script from "./collections.vue?vue&type=script&lang=ts&"
export * from "./collections.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports